<template>
  <div
    ref="pickerWrap"
    class="color-picker-dropdown-wrap"
    :class="{ vertical: vertical, invisible: !show }"
    @click.stop="$emit('focusChange')"
  >
    <color-picker
      :selected-color="selectedColor"
      :colors="colors"
      @selectColor="handleColorItemClick"
      @predefinedColorPick="handlePredefinedColorPick"
    />
  </div>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, ref } from 'vue';
import ColorPicker from '@/components/widgets/ColorPicker';

let vertical = ref(false);
let isInViewportTimeout: ReturnType<typeof setTimeout>;
let show = ref(false);

defineProps<{
  selectedColor: string;
  colors: string[];
}>();

const emit = defineEmits(['colorSelect', 'focusChange', 'predefinedColorPick']);

const pickerWrap = ref();

onMounted(() => {
  isInViewportTimeout = setTimeout(() => {
    const { width: windowWidth } = document.documentElement.getBoundingClientRect();
    const { right } = pickerWrap.value.getBoundingClientRect();

    if (right > windowWidth) {
      vertical.value = true;
    }
    show.value = true;
  }, 0);
});

onUnmounted(() => {
  clearTimeout(isInViewportTimeout);
});

function handleColorItemClick(color: string) {
  emit('colorSelect', color);
}

function handlePredefinedColorPick(color: string) {
  emit('predefinedColorPick', color);
}
</script>

<style lang="scss">
.color-picker-dropdown-wrap {
  left: calc(100% + 16px);
  @apply border border-solid px-4 py-2 -top-[30px] box-border border-important-border bg-important-bg absolute flex items-center rounded-lg;

  &.vertical {
    @apply items-center flex-col w-10 px-4 py-2;

    .color-picker-wrap {
      @apply flex-col justify-center max-h-full;

      .item-color {
        @apply mr-0 mb-[9px];
      }

      .custom-picker-wrap {
        @apply border-0 border-t border-solid border-dividers-default;

        .custom-picker-button {
          @apply ml-0 mt-[9px];
        }
      }
    }
  }
}
</style>
